import { Slot } from "expo-router";

import { AuthLayout } from "~/component/layout";

export default function Layout() {
  return (
    <AuthLayout>
      <Slot />
    </AuthLayout>
  );
}
